const localStorageKey = 'colourSchemeAppearance';
const appearanceSelector = 'input.appearance-toggle';

const schemes = [
	'light', // default
	'dark',
];

const { localStorage } = window;

const initialMode = localStorage.getItem( localStorageKey );

if ( initialMode ) {
	setScheme( initialMode );
} else if ( window.matchMedia && window.matchMedia( '(prefers-color-scheme: dark)' ).matches ) {
	setScheme( 'dark' );
}

/**
 * Change to system default when the system changes - this may occur in two situations;
 * 1. When a user manually changes the system default while the site is open.
 * 2. When the system is set to "auto" or equivelent.
 * This should not change if a user has manually toggled and made a destinct choice, so
 * this functionality should be considered default behaviour.
 */
window.matchMedia( `(prefers-color-scheme: ${schemes[ 0 ]})` ).addEventListener( 'change', event => {
	const scheme = event.matches ? 'light' : 'dark';
	if ( ! localStorage.getItem( localStorageKey ) ) {
		setScheme( scheme );
	}
} );

/**
 * Toggle the mode and set local storage when the appearance toggle is changed.
 * This will override the system default behaviour.
 */
document.querySelector( appearanceSelector )?.addEventListener( 'click', () => {
	const htmlElement = document.querySelector( 'html' );

	let theme = 'light';

	if ( htmlElement.dataset.theme !== 'dark' ) {
		theme = 'dark';
	}

	htmlElement.dataset.theme = theme;
	localStorage.setItem( localStorageKey, theme );

	const meta = document.querySelector( 'meta[name="theme-color"]' );
	if ( meta ) {
		meta.setAttribute( 'content', theme === 'dark' ? '#000000' : '#ffffff' );
	}
} );

/**
 * Set the data attribute and ensure appearance toggle is checked where applicable.
 *
 * @param {string} scheme The appearance scheme to be set.
 */
function setScheme ( scheme = 'light' ) {
	if ( ! schemes.includes( scheme ) ) {
		scheme = schemes[ 0 ];
	}

	document.querySelector( 'html' ).dataset.theme = scheme;
	const element = document.querySelector( appearanceSelector );
	if ( element ) {
		document.querySelector( appearanceSelector ).checked = scheme === 'dark';
	}

	const meta = document.querySelector( 'meta[name="theme-color"]' );
	if ( meta ) {
		meta.setAttribute( 'content', scheme === 'dark' ? '#000000' : '#ffffff' );
	}
}

/**
 * Retrieve the scheme in order of priority;
 * 1. User selected.
 * 2. System
 * 3. Default
 *
 * @return {string} The scheme being used by the browser or system.
 */
window.getColorScheme = () => {
	if ( localStorage.getItem( localStorageKey ) ) {
		return localStorage.getItem( localStorageKey );
	}

	if ( window.matchMedia && window.matchMedia( `(prefers-color-scheme: ${schemes[ 1 ]})` ).matches ) {
		return schemes[ 1 ];
	}

	return schemes[ 0 ]; // Default.
};
